export const messages = {
  en: {
    feeReceipt: {
      search: {
        title: 'Search Conditions',
        receiptId: 'Please enter receipt ID',
        roomId: 'Please enter room/carport info, format: building-unit-room, e.g. 1-1-1',
        objType: 'Please select fee type',
        all: 'All',
        houseFee: 'House Fee',
        parkingFee: 'Parking Fee',
        startTime: 'Please select start time',
        endTime: 'Please select end time'
      },
      list: {
        title: 'Receipt Information'
      },
      table: {
        receiptId: 'Receipt ID',
        receiptCode: 'Receipt Code',
        objType: 'Fee Type',
        feeName: 'Fee Item',
        roomName: 'Room',
        payObjName: 'Owner',
        carNum: 'Carport',
        amount: 'Total Amount(¥)',
        createTime: 'Payment Time',
        feeMonth: 'Billing Month',
        cycle: 'Billing Cycle',
        payWay: 'Payment Method',
        deductionAmount: 'Discount Amount',
        lateAmount: 'Late Fee',
        acctAmount: 'Account Deduction',
        degree: 'Meter Reading (Start ~ End)'
      },
      button: {
        reprint: 'Reprint Receipt',
        reprintSmall: 'Reprint Small Receipt'
      },
      fetchError: 'Failed to fetch receipt data'
    }
  },
  zh: {
    feeReceipt: {
      search: {
        title: '查询条件',
        receiptId: '请输入收据ID',
        roomId: '请输入房屋或车位信息，格式为楼栋-单元-房屋，如1-1-1',
        objType: '请选择收费类型',
        all: '全部',
        houseFee: '房屋费',
        parkingFee: '车位费',
        startTime: '请选择开始时间',
        endTime: '请选择结束时间'
      },
      list: {
        title: '收据信息'
      },
      table: {
        receiptId: '收据ID',
        receiptCode: '收据编号',
        objType: '费用类型',
        feeName: '费用项',
        roomName: '房屋',
        payObjName: '业主',
        carNum: '车位',
        amount: '总金额(单位:元)',
        createTime: '缴费时间',
        feeMonth: '计费月',
        cycle: '缴费周期',
        payWay: '支付方式',
        deductionAmount: '优惠金额',
        lateAmount: '滞纳金',
        acctAmount: '账户抵扣',
        degree: '抄表起止度数'
      },
      button: {
        reprint: '补打收据',
        reprintSmall: '补打小票'
      },
      fetchError: '获取收据数据失败'
}
  },
  'zh-TW': {
    feeReceipt: {
      search: {
        title: '查詢條件',
        receiptId: '請輸入收據ID',
        roomId: '請輸入房屋或車位資訊，格式為樓棟-單元-房屋，如1-1-1',
        objType: '請選擇收費類型',
        all: '全部',
        houseFee: '房屋費',
        parkingFee: '車位費',
        startTime: '請選擇開始時間',
        endTime: '請選擇結束時間'
      },
      list: {
        title: '收據資訊'
      },
      table: {
        receiptId: '收據ID',
        receiptCode: '收據編號',
        objType: '費用類型',
        feeName: '費用項',
        roomName: '房屋',
        payObjName: '業主',
        carNum: '車位',
        amount: '總金額(單位:元)',
        createTime: '繳費時間',
        feeMonth: '計費月',
        cycle: '繳費週期',
        payWay: '支付方式',
        deductionAmount: '優惠金額',
        lateAmount: '滯納金',
        acctAmount: '帳戶抵扣',
        degree: '抄表起止度數'
      },
      button: {
        reprint: '補打收據',
        reprintSmall: '補打小票'
      },
      fetchError: '獲取收據數據失敗'
    }
  }
}